import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { timeAgo } from "./AdminShared";

export default function InboxesTab({ conversations, openConvo, convoMessages, onOpen }) {
  return (
    <>
      <div className="text-xs uppercase tracking-widest text-zinc-500 mb-4">
        All conversations on the platform ({conversations.length}) — click to read, no reply.
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
        <div className="lg:col-span-2 space-y-2">
          {conversations.map((c) => {
            const a = c.participants[0];
            const b = c.participants[1];
            return (
              <button
                key={c.id}
                onClick={() => onOpen(c.id)}
                data-testid={`admin-convo-${c.id}`}
                className={`w-full text-left card-surface p-3 flex items-center gap-3 hover-lift ${
                  openConvo === c.id ? "border-rose-600/50" : ""
                }`}
              >
                <Avatar className="w-9 h-9 border border-white/10 shrink-0">
                  <AvatarImage src={a?.avatar_url} />
                  <AvatarFallback className="bg-rose-600 text-white text-sm">
                    {a?.handle?.[0]?.toUpperCase()}
                  </AvatarFallback>
                </Avatar>
                <div className="min-w-0 flex-1">
                  <div className="text-sm truncate">
                    <span className="font-medium">{a?.display_name}</span>
                    <span className="text-zinc-500"> ↔ </span>
                    <span>{b?.display_name}</span>
                  </div>
                  <div className="text-xs text-zinc-500 truncate">{c.last_message_preview}</div>
                </div>
                <div className="text-[10px] uppercase tracking-widest text-zinc-500 shrink-0">
                  {timeAgo(c.last_message_at)}
                </div>
              </button>
            );
          })}
          {conversations.length === 0 && (
            <div className="card-surface p-8 text-center text-sm text-zinc-500">
              No conversations yet on the platform.
            </div>
          )}
        </div>
        <div className="lg:col-span-3 card-surface p-4 min-h-[400px]" data-testid="admin-convo-viewer">
          {openConvo && convoMessages[openConvo] ? (
            <div className="space-y-2">
              <div className="text-xs uppercase tracking-widest text-zinc-500 mb-2 border-b border-white/5 pb-2">
                Read-only observation · {convoMessages[openConvo].length} messages
              </div>
              {convoMessages[openConvo].map((m) => (
                <div key={m.id} className="flex items-start gap-3">
                  <Avatar className="w-7 h-7 border border-white/10 shrink-0">
                    <AvatarImage src={m.sender?.avatar_url} />
                    <AvatarFallback className="bg-rose-600 text-white text-[10px]">
                      {m.sender?.handle?.[0]?.toUpperCase()}
                    </AvatarFallback>
                  </Avatar>
                  <div className="min-w-0 flex-1">
                    <div className="text-xs text-zinc-500">
                      {m.sender?.display_name} · {timeAgo(m.created_at)}
                    </div>
                    <div className="text-sm text-zinc-100 break-words">{m.text}</div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="h-full flex items-center justify-center text-sm text-zinc-500 py-16">
              Select a conversation to observe.
            </div>
          )}
        </div>
      </div>
    </>
  );
}
